import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  DateInput,
  ReferenceArrayInput,
  Toolbar,
  SaveButton,
  required,
  SelectArrayInput,
  FileField,
  useCreate,
  useNotify,
  useRedirect
} from 'react-admin';

function PodcastCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = (data: any) => {
    create('podcasts', { data }, {
      onSuccess: () => {
        notify('Podcast creado con éxito');
        redirect('list', 'podcasts');
      },
      onError: (error: any) => {
        notify(`Error al crear el podcast: ${error.message}`, { type: 'error' });
      },
    });
  }

  useEffect(() => {
    document.title = 'Crear Podcast';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <FileInput
          source='portada'
          label='Imagen de Portada'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <TextInput source="titulo" validate={[required()]} />
        <DateInput source="fecha" validate={[required()]} />
        <TextInput source="autor" validate={[required()]} />
        <TextInput source="descripcion" validate={[required()]} />
        <TextInput source="slug" validate={[required()]} />
        <FileInput
          source='audio'
          label='Archivo de Audio'
          validate={[required()]}
        >
          <FileField source="src" title="title" />
        </FileInput>
        <ReferenceArrayInput source='exponente_podcasts' reference='exponentes-podcasts' label='Exponentes'>
          <SelectArrayInput optionText="nombre" />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  )
}

export default PodcastCreate;